export const cookieConsentEvents = {
  /**
   * @description
   * This event is triggered when the user modifies their preferences and only if consent has already been provided.
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onChange // "cc:onChange"
   * window.addEventListener('cc:onChange', ({ detail }) => {
   *    // detail.cookie
   *    // detail.changedCategories
   *    // detail.changedServices
   * });
   * ```
   */
  onChange: "cc:onChange",

  /**
   * @description
   * This event is triggered the very first time the user expresses their choice of consent — just like onFirstConsent — but also on every subsequent page load.
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onConsent // "cc:onConsent"
   * window.addEventListener('cc:onConsent', ({ detail }) => {
   *    // detail.cookie
   * });
   * ```
   */
  onConsent: "cc:onConsent",

  /**
   * @description
   * This event is triggered only the very first time that the user expresses their choice of consent (accept/reject).
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onFirstConsent // "cc:onFirstConsent"
   * window.addEventListener('cc:onFirstConsent', ({ detail }) => {
   *    // detail.cookie
   * });
   * ```
   */
  onFirstConsent: "cc:onFirstConsent",

  /**
   * @description
   * This event is triggered when one of the modals is hidden.
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onModalHide // "cc:onModalHide"
   * window.addEventListener('cc:onModalHide', ({ detail }) => {
   *    // detail.modalName
   * });
   * ```
   */
  onModalHide: "cc:onModalHide",

  /**
   * @description
   * This event is triggered when a modal is created and appended to the DOM.
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onModalReady // "cc:onModalReady"
   * window.addEventListener('cc:onModalReady', ({ detail }) => {
   *    // detail.modalName
   *    // detail.modal
   * });
   * ```
   */
  onModalReady: "cc:onModalReady",

  /**
   * @description
   * This event is triggered when one of the modals is visible.
   *
   * @example
   *
   * ```js
   * cookieConsentEvents.onModalShow // "cc:onModalShow"
   * window.addEventListener('cc:onModalShow', ({ detail }) => {
   *    // detail.modalName
   * });
   * ```
   */
  onModalShow: "cc:onModalShow",
};
